import React, { useEffect, useState } from 'react';
import { getUsers } from '../../../usecases/user-operations-usecase';
import { EmptyArray } from '../../../domain/empty/model';
import './style.css';
import Table from '../../molecules/tablas/view';
import CustomBox from '../../atoms/container/container';
import { Switch } from '@mui/material';
import OperationUserEdit from './edit-view';

const UsersOperationsTable = () => {
  const [users, setUsers] = useState({
    data: [],
    total: 0,
    page: 1,
    page_size: 10,
  });

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async (page = users.page, page_size = users.page_size) => {
    try {
      const result = await getUsers(page, page_size); // Example pagination
      if (result == EmptyArray) {
        setUsers(prev => ({ ...prev, data: EmptyArray }));
      } else {
        setUsers({ ...result.data, data: mapUser(result.data.data) });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const mapRole = (roleId) => {
    switch (roleId) {
      case 1:
        return 'Admin';
      case 2:
        return 'Colaborator';
      case 3:
        return 'Cajero';
      default:
        return 'Unknown';
    }
  }

  const mapUser = (data) => {
    return data.map((user) => ({
      id: user.id,
      company: user.companyName,
      name: user.name,
      email: user.email,
      role: mapRole(user.role_id),
      subscription: user.subscription_status,
      full_subscription: user.subscription,
      terms: <Switch checked={user.terms} disabled={true} />,
    }));
  }

  return (
    <CustomBox>
      <Table
        paginatedData={users}
        getFunction={fetchUsers}
        excludeList={['id']}
        headersList={['Empresa', 'Nombre', 'Email', 'Rol', 'Suscripción', 'Términos']}
      >
        <OperationUserEdit />
      </Table>
    </CustomBox>
  );
};

export default UsersOperationsTable;
